<template>
  <div
    v-if="showLoader"
    class="globalLoader bg-[#f8f9fb69] absolute top-0 left-0 w-screen h-screen z-[3000]"
    @click="clickAway"
  >
    <div class="h-full flex justify-center items-center">
      <fwb-spinner class="!w-20 !h-20 !filter-none fill-etBlue-primary" />
    </div>
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { FwbSpinner } from 'flowbite-vue'

const store = useStore()

const showLoader = ref(false)

const loading = computed(() => store.state.loading.loading)
const stopLoader = () => store.dispatch('loading/stopLoader')

function clickAway() {
  stopLoader()
  showLoader.value = false
}

watch(
  () => loading.value,
  (value) => {
    showLoader.value = value
  }
)
</script>
<style lang="scss">
// Adds blur effect to view in the background
.snackbar,
.modal-mask,
.snackbar-notification {
  p,
  h1,
  h2,
  h3,
  h4,
  .text,
  .title,
  small,
  span,
  input,
  button,
  svg {
    filter: blur(0) !important;
    -webkit-filter: blur(0) !important;
  }
}
#app *:has(.globalLoader) {
  p,
  h1,
  h2,
  h3,
  h4,
  .text,
  .title,
  small,
  span,
  input,
  button,
  svg,
  label,
  .header__inner__column.header__breadcrumbs {
    &:not(.titleLoader) {
      filter: blur(3px);
      -webkit-filter: blur(3px);
    }
  }
}

.v-progress-circular {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 2001;
  svg {
    filter: none !important;
    -webkit-filter: none !important;
    .v-progress-circular--indeterminate,
    .v-progress-circular__overlay {
      animation:
        progress-circular-dash 2s ease-in-out infinite,
        progress-circular-rotate 3s linear infinite;
    }
  }
}
</style>
